// How a subscription's state reads, in one place.
//
// The WORDS come from the server — `state_label` is the same label the
// server-rendered pages print, so the portal cannot start calling `ending`
// something else. What is decided here is only the tone, and it is decided from
// `state_class` rather than from the raw state: the backend already groups the
// six states into running, waiting on something, and over, and re-deriving that
// grouping in TypeScript would be a second opinion about it that drifts the
// first time a state is added.
import { Badge } from '@miq/design-system/components/ui/badge';

import type { Subscription } from '../data/subscriptions';

/**
 * DS badge variant per appearance group. `is-waiting` is not a failure, and
 * `is-internal` — an agreement this service minted for a deployment metricsIQ
 * runs itself, which no channel bills — is neither running nor over.
 */
const TONE: Record<string, 'default' | 'secondary' | 'outline'> = {
  'is-active': 'default',
  'is-waiting': 'secondary',
  'is-over': 'outline',
  'is-internal': 'secondary',
};

export function StateBadge({ subscription }: { subscription: Subscription }) {
  return (
    <Badge variant={TONE[subscription.state_class] ?? 'secondary'}>
      {subscription.state_label}
    </Badge>
  );
}
